<template>
  <div class="noWrap">
    {{ percentageValues }}% + {{ currencyConvert }}
  </div>
</template>

<script>
import DataTableCurrencyColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCurrencyColumn.vue';
import ProdutoTemplateMixin from 'Modules/contacard/produto/templates/produto/components/ProdutoTemplateMixin';

export default {
  name: 'ProductTotalBonusColumn',
  extends: DataTableCurrencyColumnVue,
  mixins: [ProdutoTemplateMixin],
  computed: {
    columnType() {
      return 'MARGEM';
    },
  },
};
</script>
